<template>
    <div>
        <r-button type="link" @click="showModal">{{buttonLabelText}}</r-button>
        <v-modal v-if="isModalVisible" :title="documentType" @close="closeModal" size="large"
                 class="kyc-review-document-modal">
            <template v-if="documentImageURL" slot="contents">
                <div class="modal-content modal-content-secondary">
                    <img :src="documentImageURL" style="display:block; width: 70%; margin: 0 auto"/>
                </div>
                <rejection-form v-if="isRejectionFormVisible" class="modal-content" v-model="rejectionReason"
                                :validate="$v.rejectionReason"/>
                <template v-else>
                    <review-details v-if="document.hasReview" :document="document" class="modal-content"/>
                    <document-analysis :document="document" class="modal-content"/>
                </template>
            </template>
            <template v-if="isRejectionFormVisible">
                <v-icon-button slot="left-actions" @click="closeRejectionForm">
                    <v-icon slot="left-icon" icon="arrow-left"/>
                    Go Back
                </v-icon-button>
                <r-button slot="right-actions" @click="confirmReject" type="danger">Confirm Rejection</r-button>
            </template>
            <template v-else slot="left-actions">
                <r-button v-if="!document.isRejected" :class="{'inline-s': !document.isAccepted}"
                          @click="showRejectionForm" type="danger">Reject
                </r-button>
                <r-button v-if="!document.isAccepted" @click="acceptDocument" type="primary">Accept</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import _ from '@/common/helpers';
    import {vIcon, vIconButton} from '@/components/form';
    import {required} from 'vuelidate/lib/validators';
    import vModal from '../modal/v-modal';
    import ReviewDetails from './review-details';
    import DocumentAnalysis from './document-analysis';
    import RejectionForm from './rejection-form';

    export default {
        name: 'review-document-modal',
        components: {
            vModal,
            vIcon,
            vIconButton,
            ReviewDetails,
            DocumentAnalysis,
            RejectionForm,
        },
        props: {
            document: {
                type: Object,
                required: true,
            },
            buttonLabel: {
                type: String,
                required: false,
                default: '',
            },
            isInitModalVisible: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            documentType() {
                return _.capitalize(_.unKebabCase(this.document.documentType));
            },
            buttonLabelText() {
                return this.buttonLabel || this.documentType;
            },
        },
        data() {
            return {
                isModalVisible: false,
                isRejectionFormVisible: false,
                documentImageURL: null,
                rejectionReason: {
                    type: null,
                    message: null,
                },
            };
        },
        validations: {
            rejectionReason: {
                type: {required},
                message: {required},
            },
        },
        created() {
            if (this.isInitModalVisible) {
                this.showModal();
            }
        },
        methods: {
            async showModal() {
                this.isModalVisible = true;
                this.isRejectionFormVisible = false;
                if (this.documentImageURL === null) {
                    this.documentImageURL = await this.fetchDocumentImageURL();
                }
            },
            closeModal() {
                this.isModalVisible = false;
                this.$emit('close');
            },
            showRejectionForm() {
                this.isRejectionFormVisible = true;
            },
            closeRejectionForm() {
                this.isRejectionFormVisible = false;
            },
            async confirmReject() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.closeModal();
                    this.$emit('reject', this.document, this.rejectionReason);
                }
            },
            async acceptDocument() {
                this.closeModal();
                this.$emit('accept', this.document);
            },
            async fetchDocumentImageURL() {
                const params = {
                    id: this.document.fileId,
                };
                try {
                    const {fields: {_links}} = await this.$api(({files}) => files.get(params));
                    const imageLink = _links.find(({rel}) => rel === 'signedLink');
                    return imageLink && imageLink.href;
                } catch (error) {
                    this.closeModal();
                    this.$toast.negative('Document image could not be loaded.');
                    return false;
                }
            },
        },
    };
</script>
